var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckYourEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 130,
    viewBox: "0 0 117 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.1667 103V128.333H45.8333V61.8332C45.8333 49.5908 35.909 39.6665 23.6667 39.6665M20.5 64.9998H26.8333M23.6667 39.6665H93.3333C105.576 39.6665 115.5 49.5908 115.5 61.8332V96.6665C115.5 100.163 112.663 103 109.167 103H7.83333C4.33733 103 1.5 100.163 1.5 96.6665V61.8332C1.5 49.5908 11.4243 39.6665 23.6667 39.6665ZM71.1667 20.6665V64.9998M71.1667 20.6665H102.833V1.6665H71.1667V20.6665ZM71.1603 62.6248C69.8493 62.6312 68.7917 63.6952 68.7917 65.0062C68.7917 66.3172 69.8557 67.3812 71.1667 67.3748C72.4777 67.3748 73.5417 66.3108 73.5417 64.9998C73.5417 63.6888 72.4777 62.6248 71.1603 62.6248Z",
    stroke: "#90A8C1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckYourEmail);
export default __webpack_public_path__ + "static/media/checkYourEmail.9f16316065d6f795fc3c08f47388521f.svg";
export { ForwardRef as ReactComponent };